






























































































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import HelpMessage from "../../../../../components/HelpMessage/HelpMessage.vue";
import Icon from "../../../../../components/Icon/Icon.vue";
import { IterableListItem } from "../../../../../shared/utils/IterableItemFactory";
import { ActionExecuteTypeEnum } from "../../types";
import { PostActionBuilder } from "../ActionTypes/PostActionBuilder";
import { PostActionStructure } from "../ActionTypes/PostActionStructure";
import { PostAction } from "../PostAction/PostAction";
import PostActionDelayPreview from "./PostActionDelay/PostActionDelayPreview.vue";

@Component({
  data() {
    return {
      PostAction,
      ActionExecuteTypeEnum
    }
  },
  components: {
    Icon,
    HelpMessage,
    PostActionDelayPreview
  }
})
export default class SelectPostActionItem extends Vue {
  @Prop() action!: IterableListItem<PostActionStructure>

  @Prop() builder!: PostActionBuilder | undefined

  @Prop() arrowUpDisabled!: boolean

  @Prop() arrowDownDisabled!: boolean

  @Emit()
  editClick() {
    return this.action
  }

  @Emit()
  removeClick() {
    return this.action.guid
  }

  @Emit()
  arrowUpClick() {
    return null
  }

  @Emit()
  arrowDownClick() {
    return null
  }
}
